import { InvestmentRange } from 'types'
import { numberToDollars } from 'utils'

export const formatDollarRange = (
  { min = 0, max = 0 }: InvestmentRange = { min: 0, max: 0 }
) =>
  `${numberToDollars(min, undefined, 0)} - ${numberToDollars(
    max,
    undefined,
    0
  )}`
